import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityApplicationsByIdSlice } from './get';
import { patchCoreDataSecurityApplicationByIdSlice } from './patch';

export const coreDataSecurityApplicationsByIdReducers = combineReducers({
	get: getCoreDataSecurityApplicationsByIdSlice.asyncReducers,
	patch: patchCoreDataSecurityApplicationByIdSlice.asyncReducers
});

export const coreDataSecurityApplicationsByIdWatchers = combineAllWatchers([
	getCoreDataSecurityApplicationsByIdSlice.asyncWatchers,
	patchCoreDataSecurityApplicationByIdSlice.asyncWatchers
]);
